import { API_ADMIN_WORKSPACE } from '@he-novation/config/apis/admin-api';
import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import type { WorkspaceOptions, WorkspaceUpdate } from '@he-novation/config/types/client.types';

export function asyncAdminWorkspaceCreate(
    user: {
        email: string;
        firstname?: string;
        lastname?: string;
        locale?: string;
    },
    workspace: WorkspaceOptions
) {
    return buildApiCall(API_ADMIN_WORKSPACE.CREATE)({
        body: {
            user,
            workspace
        }
    }).then((w) => ({
        ...w,
        created: new Date(w.created)
    }));
}

export function asyncAdminWorkspaceUpdate(workspaceName: string, options: WorkspaceUpdate) {
    return buildApiCall(API_ADMIN_WORKSPACE.PATCH)({
        params: { workspaceName },
        body: options
    }).then((w) => ({
        ...w,
        created: new Date(w.created)
    }));
}

export function asyncAdminWorkspaceGet(workspaceName: string) {
    return buildApiCall(API_ADMIN_WORKSPACE.GET)({
        params: { workspaceName }
    }).then((w) => ({
        ...w,
        created: new Date(w.created)
    }));
}
